export const ALERT_RESPONSE_MAP_ID = '4504f8b37365c3d0';
export const ALERT_RESPONSE_MAP_ZOOM = 16;
export const ALERT_RESPONSE_MAP_PADDING = { top: 48, right: 64, bottom: 40, left: 64 };
export const ALERT_RESPONSE_MAP_REFIT_DELAY_MS = 150;
export const ALERT_RESPONSE_MAX_NEIGHBOUR_COUNT = 8;
export const ALERT_RESPONSE_COLLAPSED_CONTROL_COUNT = 5;
export const EARTH_RADIUS_METERS = 6371000;

/**
 * The whole public alert-response surface is wired to the real, merged
 * backend (AcknowledgementLinkController): a published short link
 * deliberately OUTSIDE the normal /api prefix - GET /ack/{token} (status
 * only), GET /ack/{token}/page (page data), POST /ack/{token}/confirm
 * (acknowledge), POST /ack/{token}/response (capture response) and
 * POST /ack/{token}/revoke ("Not you?"). The token is always a path
 * segment, never a query param.
 */
export const ACK_LINK_ROUTE_SEGMENT = 'ack';

/** SMS ack links carry `?channel=sms`, so the confirm call can record SmsDeepLink instead of EmailLink. */
export const ACK_LINK_CHANNEL_PARAM = 'channel';
export const ACK_LINK_SMS_CHANNEL = 'sms';

/**
 * These are unauthenticated, token-scoped endpoints reached from an SMS link,
 * not a logged-in session. They must never trigger TokenInterceptor's bearer
 * attachment or its refresh/redirect-to-login handling on a 401 - an expired
 * or already-used link should render this page's own "link is no longer
 * valid" state, not silently bounce a supervisor with no account to /login.
 */
export const PUBLIC_ALERT_RESPONSE_ENDPOINTS = [`/${ACK_LINK_ROUTE_SEGMENT}/`];
